import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { ContentStorePropTypes } from "../../../utilities/propTypes";
import GeneralItemCard from "./generalItemCard";
import GeneralContentShimmer from "../../shimmer/generalContentShimmer";
import withShimmer from "../../shimmer/withShimmer";
import { postScrollHeightToParent } from "../../../utilities/postMessage";
import "./generalItemView.scss";

class GeneralItemView extends Component {
  componentDidUpdate() {
    postScrollHeightToParent();
  }

  generateItemCards = () => {
    const {
      generalItemStore: { data: contentItems }
    } = this.props;

    return (
      contentItems &&
      contentItems.map(item => (
        <GeneralItemCard key={item.id} cardData={item} />
      ))
    );
  };

  render() {
    const { generalItemStore } = this.props;

    return (
      <div className="learn-content-list">
        <h2 className="text-center mt-40">All learning materials</h2>
        <div className="media-grid">
          <div className="row">
            {withShimmer(
              this.generateItemCards(),
              GeneralContentShimmer,
              generalItemStore.loadingStatus
            )}
          </div>
        </div>
      </div>
    );
  }
}

GeneralItemView.propTypes = {
  generalItemStore: ContentStorePropTypes.isRequired
};

export default inject("generalItemStore")(observer(GeneralItemView));
